import script from "./comAlarm.vue?vue&type=script&setup=true&lang=js"
export * from "./comAlarm.vue?vue&type=script&setup=true&lang=js"

import "./comAlarm.vue?vue&type=style&index=0&id=7f8edfbe&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f8edfbe"]])

export default __exports__